import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconEdit from '@/icons/Edit.svg';

export const ArticleCustomsInformationsProvidedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'article_customs_informations_provided'>;
}) => {
  const creatorName = activity.creator.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconEdit />}
      message={
        <BaseActivityText>
          <Trans id="activities.article_customs_informations_provided.message">
            Customs information provided by <strong>{creatorName}</strong>
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
